import axios from 'axios'

export default class ApiResource {

  #user;
  #api_prefix = '';
  #auth_prefix = '';
  #api_base;
  constructor(user, api_base, api_prefix, auth_prefix) {
    this.#user = user;
    this.#api_prefix = api_prefix;
    this.#api_base = api_base;
    this.#auth_prefix = auth_prefix;
  }
  getToken()
  {
    return this.#user.getToken()
  }
  getPrevious()
  {
    return this.#user.getPrevious()
  }

  signIn(login, password)
  {
    this.#user.setToken('');
    const context = this;
    return axios.post(this.#generateApiAuthUrl('sign-in'),
        {
          username: login,
          password: password
        },
        {
      crossdomain: true,
      headers: this.#getHeaders()
    }).then(function(response) {
      if(response?.data?.token){
        context.#user.setToken(response.data.token);
      } else {
        throw new Error("Incorrect login or password")
      }
    });
  }
  signUp(name, login, password)
  {
    this.#user.setToken('');
    const context = this;
    return axios.post(this.#generateApiAuthUrl('sign-up'),
        {
          name: name,
          username: login,
          password: password
        },
        {
          crossdomain: true,
          headers: this.#getHeaders()
        }).then(function(response) {

      if(response?.data?.id > 0){
        context.#redirectToSignIn();
      } else {
        throw Error (`Login is busy '${login}'`);
      }
    });
  }

  #redirectToPreviousLink()
  {
    let prev = this.#user.getPrevious();
    if(prev){
      document.location.href = prev
    }
    document.location.href = '/lists'
  }
  get(url){
    const context = this;
    return  axios.get(this._generateApiUrl(url), {
      crossdomain: true,
      headers: this.#getAuthorizedHeaders()
    })
    .catch(function (error){
      if(error.response.status === 401){
        context.#authenticate();
      }
      throw error;
    })
  }

  post(url, data){
    return axios.post(this._generateApiUrl(url), data,
      {
      crossdomain: true,
      headers: this.#getAuthorizedHeaders()
    })
  }
  put(url, data){
    return axios.put(this._generateApiUrl(url), data,
      {
        crossdomain: true,
        headers: this.#getAuthorizedHeaders()
      })
  }
  patch(url, data){
    return axios.patch(this._generateApiUrl(url), data,
        {
          crossdomain: true,
          headers: this.#getAuthorizedHeaders()
        })
  }
  delete(url){
    return axios.delete(this._generateApiUrl(url),
        {
          crossdomain: true,
          headers: this.#getAuthorizedHeaders()
        })
  }

  #authenticate()
  {
    this.#savePreviousUri();

    if(this.#user.getPrevious() && !this.#user.getPrevious().endsWith('sign-in')){
      this.#redirectToSignIn();
    }
  }
  #redirectToSignIn()
  {
    document.location.href = '/sign-in'
  }
  #savePreviousUri()
  {
    this.#user.setPrevious(window.location.href);
  }

  _generateApiUrl(url)
  {
    //console.log( this.#api_base + this.#api_prefix + url)
    return (this.#api_base + this.#api_prefix + url)
  }

  #generateApiAuthUrl(url)
  {
    //console.log( this.#api_base + this.#auth_prefix + url)
    return (this.#api_base + this.#auth_prefix + url)
  }
  #getAuthorizedHeaders()
  {
    let headers = this.#getHeaders();
    headers['Authorization'] = "Bearer " + this.#user.getToken();
    return headers
  }
  #getHeaders()
  {
    return {
      'Accept' : "application/json",
      'Content-Type': 'application/json; charset=UTF-8',
      'Cache-Control': 'no-cache'
    }
  }
}


